import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-hhg-shipment-address-template',
    templateUrl: './hhg-shipment-address-template.component.html',
    styleUrls: ['./hhg-shipment-address-template.component.css'],
    standalone: false
})
export class HhgShipmentAddressTemplateComponent implements OnInit {
  @Input() typeOfAddress;
  addressLine1: any;
  addressLine2: any;
  cityStateZip: any;
  country: any;
  primaryPhone: any;
  ext: any;
  alternativePhone: any;
  email: any;
  otherContactInformation: any;
  showOriginDestinationForm: boolean;
  showAddreseeForm: boolean;

  addreseeAddressLine1: any;
  addreseeAddressLine2: any;
  addreseeCity: any;
  addreseeState: any;
  addreseeZip: any;
  addreseeCountry: any;
  addreseePhone: any;
  addreseeExt: any;
  addreseeEmail: any;

  constructor() { }

  ngOnInit() {
    if (this.typeOfAddress === 'Origin') {
      this.showOriginDestinationForm = true;
      this.addressLine1 = 'Origin Line 1';
      this.addressLine2 = 'Origin Line 2';
      this.cityStateZip = 'city, State & Zip';
      this.country = 'Country';
      this.primaryPhone = 'Primary Phone';
      this.alternativePhone = 'Alternative Phone';
      this.email = 'Email';
      this.ext = 'Ext';
      this.otherContactInformation = 'Other Contact Information';
    } else if (this.typeOfAddress === 'Destination') {
      this.showOriginDestinationForm = true;
      this.addressLine1 = 'Destination Line 1';
      this.addressLine2 = 'Destination Line 2';
      this.cityStateZip = 'city, State & Zip';
      this.country = 'Country';
      this.primaryPhone = 'Primary Phone';
      this.alternativePhone = 'Alternative Phone';
      this.email = 'Email';
      this.ext = 'Ext';
      this.otherContactInformation = 'Other Contact Information';
    } else if (this.typeOfAddress === 'Shipper') {
      this.showAddreseeForm = true;
      this.addreseeAddressLine1 = 'Shipper Line 1';
      this.addreseeAddressLine2 = 'Shipper Line 2';
      this.addreseeCity = 'City';
      this.addreseeState = 'State';
      this.addreseeZip = 'Zip';
      this.addreseeCountry = 'Country';
      this.addreseePhone = 'Phone';
      this.addreseeExt = 'Ext';
      this.addreseeEmail = 'Email';
    } else if (this.typeOfAddress === 'Consignee') {
      this.showAddreseeForm = true;
      this.addreseeAddressLine1 = 'Consignee Line 1';
      this.addreseeAddressLine2 = 'Consignee Line 2';
      this.addreseeCity = 'City';
      this.addreseeState = 'State';
      this.addreseeZip = 'Zip';
      this.addreseeCountry = 'Country';
      this.addreseePhone = 'Phone';
      this.addreseeExt = 'Ext';
      this.addreseeEmail = 'Email';
    } else if (this.typeOfAddress === 'Bill To') {
      this.showAddreseeForm = true;
      this.addreseeAddressLine1 = 'Bill Line 1';
      this.addreseeAddressLine2 = 'Bill Line 2';
      this.addreseeCity = 'City';
      this.addreseeState = 'State';
      this.addreseeZip = 'Zip';
      this.addreseeCountry = 'Country';
      this.addreseePhone = 'Phone';
      this.addreseeExt = 'Ext';
      this.addreseeEmail = 'Email';
    }
  }

}
